// src/components/apps/SharePointHR/SharePointBreadcrumb.jsx
import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";

/**
 * Props:
 *   pathStack: Array of { id, name } representing the folder hierarchy
 *   onNavigate: (index) => void -- called when a breadcrumb is clicked
 *              index -1 means root, 0 means first folder, etc.
 */
const SharePointBreadcrumb = ({ pathStack, onNavigate }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 2 }}
    >
      <Link
        component="button"
        variant="body1"
        underline="hover"
        sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => onNavigate(-1)}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
        HR Documents
      </Link>
      {pathStack.map((folder, index) => {
        const isLast = index === pathStack.length - 1;
        return isLast ? (
          <Typography key={folder.id} color="text.primary" variant="body1">
            {folder.name}
          </Typography>
        ) : (
          <Link
            key={folder.id}
            component="button"
            variant="body1"
            underline="hover"
            sx={{ cursor: "pointer" }}
            onClick={() => onNavigate(index)}
          >
            {folder.name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default SharePointBreadcrumb;
